import { render, staticRenderFns } from "./live-across.vue?vue&type=template&id=26738593&scoped=true"
import script from "./live-across.vue?vue&type=script&lang=js"
export * from "./live-across.vue?vue&type=script&lang=js"
import style0 from "./live-across.vue?vue&type=style&index=0&id=26738593&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26738593",
  null
  
)

export default component.exports